module.exports = __webpack_public_path__ + "static/media/resell-marker@3x.f896d15d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/resell-marker@3x.png
// module id = 542
// module chunks = 6